module.exports = __webpack_public_path__ + "img/collection-weddingRingsWhitegold@2x.5ee9798.webp";